module.exports = __webpack_public_path__ + "img/img_login.8df48202.jpg";